import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _ModesVertCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M12 17v4.5M12 2.5V7" }), _jsx("circle", { cx: 12, cy: 12, r: 4.5, stroke: "currentColor" })] }) });
}
const ModesVertCustom = forwardRef(_ModesVertCustom);
export { ModesVertCustom };
